export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/871badaa37afb70c2a47bacc1bfa789e.jpg" 
          alt="Executive AI Environment" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0f]/70 via-[#0a0a0f]/80 to-[#0a0a0f]"></div>
      </div>

      <div className="absolute inset-0 bg-gradient-to-br from-violet-600/10 via-transparent to-blue-600/10"></div>
      
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-violet-600/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center w-full">
        <div className="inline-block px-4 py-2 bg-violet-600/10 border border-violet-500/30 rounded-full mb-8">
          <span className="text-sm text-violet-300 whitespace-nowrap">Intelligence Artificielle Exécutive</span>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
          Votre Assistant Exécutif IA,
          <br />
          <span className="bg-gradient-to-r from-violet-400 via-purple-400 to-blue-400 bg-clip-text text-transparent">
            disponible 24/7
          </span>
        </h1>

        <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
          Automatisez l'opérationnel, concentrez-vous sur la décision.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a 
            href="https://calendly.com/contact-assistantexecutifai/30min?back=1&month=2026-01" 
            target="_blank" 
            rel="noopener noreferrer"
            className="px-8 py-4 bg-gradient-to-r from-violet-600 to-blue-600 rounded-lg text-base font-semibold hover:shadow-2xl hover:shadow-violet-500/40 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Réserver une consultation gratuite
          </a>
          <button className="px-8 py-4 bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg text-base font-semibold hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer">
            Voir comment ça fonctionne
          </button>
        </div>

        <div className="mt-16 grid grid-cols-3 gap-8 max-w-3xl mx-auto">
          <div className="text-center">
            <div className="text-3xl font-bold bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-transparent">24/7</div>
            <div className="text-sm text-gray-400 mt-2 whitespace-nowrap">Disponibilité totale</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-transparent">&lt;48h</div>
            <div className="text-sm text-gray-400 mt-2 whitespace-nowrap">Déploiement rapide</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-transparent">100%</div>
            <div className="text-sm text-gray-400 mt-2 whitespace-nowrap">Confidentiel</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce cursor-pointer">
        <i className="ri-arrow-down-line text-3xl text-violet-400"></i>
      </div>
    </section>
  );
}